/**
 *
 * Asynchronously loads the component for EventDetail
 *
 */

import loadable from '../../utils/loadable';

export default loadable(() => import('./index'));
